import CustomUspAttractions from '@public/icons/usp_6_new.svg';
import React, { SVGProps } from 'react';

type CustomUspAttractionsWrapperProps = SVGProps<SVGSVGElement>;
const CustomUspAttractionsWrapper: React.FC<CustomUspAttractionsWrapperProps> = (props) => {
  return <CustomUspAttractions {...props} />;
};

export default CustomUspAttractionsWrapper;
